import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  listSystemKey: [],
  staticNavbar: [],
  listCount: {},
  listTabs: [],
  listMenu: null,
  userInfo: {},
  isAuthenticated: false,
  lang: 'vi',
  isAppInitialized: false,
}

export const appGlobalSlice = createSlice({
  name: 'appGlobal',
  initialState,
  reducers: {
    getListSystemKey: (state, action) => {
      state.listSystemKey = action.payload
    },
    getStaticNav: (state, action) => {
      state.staticNavbar = action.payload
    },
    setListTabs: (state, action) => {
      state.listTabs = action.payload
    },
    setListMenu: (state, action) => {
      state.listMenu = action.payload
    },
    changeAuthorization: (state, action) => {
      state.isAuthenticated = action.payload
    },
    setListCount: (state, action) => {
      state.listCount = action.payload
    },
    setLang: (state, action) => {
      state.lang = action.payload
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload
    },
    setAppInitialized: (state, action) => {
      state.isAppInitialized = action.payload
    },
  },
})

export const {
  getListSystemKey,
  changeAuthorization,
  setListTabs,
  setListMenu,
  getStaticNav,
  setListCount,
  setLang,
  setUserInfo,
  setAppInitialized,
} = appGlobalSlice.actions

export default appGlobalSlice.reducer

// Backward-compatible selectors for legacy pages
export const selectListSystemKey = (state: any) => state.appGlobal?.listSystemKey ?? []
export const selectStaticNav = (state: any) => state.appGlobal?.staticNavbar ?? []
export const selectListTabs = (state: any) => state.appGlobal?.listTabs ?? []
export const selectListMenu = (state: any) => state.appGlobal?.listMenu ?? null
export const selectIsAuthenticated = (state: any) => state.appGlobal?.isAuthenticated ?? false
export const selectListCount = (state: any) => state.appGlobal?.listCount ?? {}
export const selectLang = (state: any) => state.appGlobal?.lang ?? 'vi'
export const selectIsAppInitialized = (state: any) => state.appGlobal?.isAppInitialized ?? false

// Legacy aliases
export const selectUserInfo = (state: any) => state.appGlobal?.userInfo ?? null
